import React from 'react';
import styles from './SheetHeader.module.scss';
import { Container, Row, Col } from 'react-bootstrap';

const SheetHeader = () => {
  return (
    <Container className={styles.SheetHeader} data-testid="SheetHeader">
      <div className={styles.TopHeader}>
        <Row>
          <Col>
            <h1 className={styles.Title}>Timesheet</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className={styles.SubHeading}>
              As you may have heard of UKG (formerly known as Kronos) Payroll
              Software outage, please be assured that we are aware of the
              situation and that healthcare professionals at affected hospitals
              will be paid on time.
            </p>
          </Col>
        </Row>
      </div>
      <Row>
        <Col>
          <p>
            Please submit your timesheet below by Monday 5:00 PM to prevent any
            delays.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default SheetHeader;
